module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExt.9fdbacb.ttf";